import {createContext} from 'react';

import {StorageManager} from 'common/contexts/storage-manager/types';
import {createRootContextHook} from 'common/util/react';

export const localStorageContext = createContext<StorageManager>(null);
export const LocalStorageManagerProvider = localStorageContext.Provider;
export const LocalStorageManagerConsumer = localStorageContext.Consumer;
export const useLocalStorageManager = createRootContextHook(`localStorageManager`);

export const sessionStorageContext = createContext<StorageManager>(null);
export const SessionStorageManagerProvider = sessionStorageContext.Provider;
export const SessionStorageManagerConsumer = sessionStorageContext.Consumer;
export const useSessionStorageManager = createRootContextHook(`sessionStorageManager`);
